import { render, staticRenderFns } from "./WorkAuthorsString.vue?vue&type=template&id=1812d394&scoped=true"
import script from "./WorkAuthorsString.vue?vue&type=script&lang=js"
export * from "./WorkAuthorsString.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1812d394",
  null
  
)

export default component.exports